import styled from 'styled-components';
import { SpinnerStyled } from '../SpinnerStyled';

export const SpinnerStyledOV = styled(SpinnerStyled)``;
